/**
 * Application-wide constants — mirrors the Angular Constants class.
 * Uses plain `const` objects instead of enums (erasableSyntaxOnly).
 */

// ── Ground KPI codes ──────────────────────────────────────────────
export const KPI_CORE_GROUND = 'C_G';
export const KPI_E_GROUND = 'E_G';
export const KPI_EXT_GROUND = 'EXT_G';
export const KPI_ORDERED_GROUND = 'ORD_G';
export const KPI_UNKNOWN_GROUND = 'UNK_G';
export const KPI_SP_GROUND = 'SP_G';
export const KPI_SQ_GROUND = 'SQ_G';

// ── Plan KPI codes ────────────────────────────────────────────────
export const KPI_CORE = 'C';
export const KPI_E = 'E';
export const KPI_EXT = 'EXT';
export const KPI_ART = 'ART';
export const KPI_SW = 'SW';
export const KPI_SP = 'SP';
export const KPI_SQ = 'SQ';
export const KPI_AI = 'AI';

// ── KPI display name ↔ code mapping ──────────────────────────────
export const KPI_DISPLAY_NAME_TO_CODE: Record<string, string> = {
  'Planned articles': 'ART',
  Core: 'C',
  Extended: 'E',
  Excitement: 'EXT',
};

// ── Time hierarchy tokens ─────────────────────────────────────────
export const Quarter = 'Q';
export const Period = 'P';
export const Week = 'W';

export const TIME_WEEK = 'Week';
export const TIME_PERIOD = 'Period';
export const TIME_QUARTER = 'Quarter';

// ── Plan levels ───────────────────────────────────────────────────
export const PLANLEVEL_PLAN = 'Plan';
export const PLANLEVEL_GROUND = 'Ground';

// ── Tooltip helpers ───────────────────────────────────────────────
export const Tooltip_Plan = 'plan';
export const Tooltip_Ground = 'gnd';

// ── API endpoints ─────────────────────────────────────────────────
export const TIMELINE_API = '/api/Time/timeline-configurations';
export const WORKSPACE_DEPARTMENT_API = '/api/Workspace/department/';
export const WORKSPACE_DEPARTMENT_STORE_MARKET_API = '/api/Workspace/department/store/';
export const WORKSPACE_DEPARTMENT_ONLINE_MARKET_API = '/api/Workspace/department/online/';
export const GROUND_DEPARTMENT_API = '/api/Ground/department/';
export const WORKSPACE_SECTION_STORE_API = '/api/Workspace/section/store/';
export const WORKSPACE_SECTION_ONLINE_API = '/api/Workspace/section/online/';
export const GROUND_SECTION_API = '/api/Ground/section/';

// ── SCA & Market workspace APIs ───────────────────────────────────
export const HANDLE_SCA_SELECTION_API = '/api/Workspace/department/handle-sca-selection/';
export const DELETE_NON_MAIN_MARKET_API = '/api/Workspace/department/delete-non-main-market/';
export const COPY_MAIN_MARKET_API = '/api/Workspace/department/copy-main-market/';
export const COPY_ARTICLE_PLAN_TO_ALL_REGIONS_API = '/api/Workspace/department/copy-article-plan-to-all-regions/';
export const PUBLISH_METADATA_API = '/api/metadata/publish/department/';
export const SECTION_METADATA_API = '/api/metadata/section/';
export const PUBLISH_DEPARTMENT_API = '/api/PublishPlan/department/';